import { render } from "./NotFound.vue?vue&type=template&id=76d51cf4"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=76d51cf4&lang=scss"
script.render = render

export default script